import { render, staticRenderFns } from "./SnapshotCard.vue?vue&type=template&id=40b50198"
import script from "./SnapshotCard.vue?vue&type=script&lang=ts"
export * from "./SnapshotCard.vue?vue&type=script&lang=ts"
import style0 from "./SnapshotCard.vue?vue&type=style&index=0&id=40b50198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports